import { IWizardStep, IWizardStepsGroup } from '../models/IWizardStep'

import { isWizardStepsGroup } from './isWizardStepsGroup'

export const getAllWizardSteps = (data: (IWizardStep | IWizardStepsGroup)[]) => {
  return data.flatMap((item) => (isWizardStepsGroup(item) ? item.steps : [item]))
}
